import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Spin, Select, Popover, Dropdown } from "antd";
import RefreshIcon from "../../../core/common/tooltip-content/refresh";
import CommonFooter from "../../../core/common/footer/commonFooter";
import Table1 from "../../../core/pagination/datatable";
import { API_BASE_URL } from "../Config/Config";
import Swal from "sweetalert2";
// import axios from "axios";
import dayjs from "dayjs";
import { MailOutlined } from "@ant-design/icons";
import Location from "./Location";
import Devicesmodel from "./Devicesmodel";
import ConfigrationModel from "./ConfigrationModel";
import EditClient from "./EditClient";
import Notify from "./Notify";
import GenerateLicence from "./GenerateLicence";

const Companies = () => {
  const userData = JSON.parse(
    sessionStorage.getItem("HealthCheckuser") || "[]"
  );
  const columns = [
    {
      title: "SuperId",
      dataIndex: "SuperId",
      sorter: (a, b) => (a?.SuperId || 0) - (b?.SuperId || 0),
    },
    {
      title: "Client",
      dataIndex: "OrgName",
      render: (_, record) => {
        const truncated =
          record?.OrgName?.length > 45
            ? record?.OrgName?.substring(0, 45) + "..."
            : record?.OrgName;
        return (
          <div className="d-flex align-items-center gap-4">
            <span
              className={
                record?.IsActive
                  ? "badge bg-success rounded-circle"
                  : "badge bg-danger rounded-circle"
              }
              style={{
                width: 15,
                height: 15,
                display: "inline-block",
              }}
            ></span>
            <span title={record?.OrgName}>{truncated}</span>
          </div>
        );
      },

      sorter: (a, b) => (a?.OrgName || "").localeCompare(b?.OrgName || ""),
    },

    {
      title: "Product",
      dataIndex: "ProductType",
      sorter: (a, b) =>
        (a?.ProductType || "").localeCompare(b?.ProductType || ""),
    },
    {
      title: "Email",
      dataIndex: "PrimaryEmailAddr",
      render: (text) => {
        if (!text) return "-";

        const content = (
          <div style={{ maxWidth: 220, wordBreak: "break-word" }}>{text}</div>
        );

        return (
          <Popover
            content={content}
            trigger={["hover", "click"]}
            placement="top"
          >
            <MailOutlined style={{ cursor: "pointer", fontSize: 16 }} />
          </Popover>
        );
      },
      sorter: (a, b) =>
        (a?.PrimaryEmailAddr || "").localeCompare(b?.PrimaryEmailAddr || ""),
    },
    {
      title: "Mobile",
      dataIndex: "PrimaryMobile",
      render: (value) => (value ? value : "-"),
    },
    {
      title: "SubscribedOn",
      dataIndex: "SubscribedOn",
      sorter: (a, b) => {
        const d1 = dayjs(a?.SubscribedOn, "DD-MM-YY", true);
        const d2 = dayjs(b?.SubscribedOn, "DD-MM-YY", true);

        return (
          (d1.isValid() ? d1.valueOf() : 0) - (d2.isValid() ? d2.valueOf() : 0)
        );
      },
    },
    // {
    //   title: "Actions",
    //   dataIndex: "actions",
    //   render: (_, record) => (
    //     <div className="action-icon d-inline-flex align-items-center">
    //       <Link
    //         to="#"
    //         className="p-2 d-flex align-items-center border rounded me-2"
    //         data-bs-toggle="modal"
    //         data-bs-target="#company_detail"
    //         onClick={() => fetchCompanyDetail(record)}
    //       >
    //         <i className="ti ti-eye" />
    //       </Link>
    //       <Link
    //         to="#"
    //         className="me-2 p-2 d-flex align-items-center border rounded"
    //         data-bs-toggle="modal"
    //         data-bs-target="#Notification"
    //         onClick={() => fetchCompanyDetails(record)}
    //       >
    //         <i className="ti ti-bell" />
    //       </Link>
    //     </div>
    //   ),
    // },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (_, record) => {
        const items = [
          {
            key: "1",
            label: (
              <div
                data-bs-toggle="modal"
                data-bs-target="#company_detail"
                onClick={() => fetchCompanyDetail(record)}
              >
                <i className="ti ti-eye me-2" />
                View Details
              </div>
            ),
          },
          {
            key: "2",
            label: (
              <div
                data-bs-toggle="modal"
                data-bs-target="#EditClient"
                onClick={() => setSelectedEditRecord(record)}
              >
                <i className="ti ti-edit me-2" />
                Edit Client
              </div>
            ),
          },
          {
            key: "3",
            label: (
              <div
                data-bs-toggle="modal"
                data-bs-target="#Notification"
                onClick={() => setSelectedNotifyRecord(record)}
              >
                <i className="ti ti-bell me-2" />
                Send Notification
              </div>
            ),
          },
          {
            key: "4",
            label: (
              <div
                data-bs-toggle="modal"
                data-bs-target="#locationModal"
                onClick={() => setSelectedLocationRecord(record)}
              >
                <i className="ti ti-current-location me-2" />
                Location
              </div>
            ),
          },
          {
            key: "5",
            label: (
              <div
                data-bs-toggle="modal"
                data-bs-target="#devicemodel"
                onClick={() => setSelectedDeviceRecord(record)}
              >
                <i className="ti ti-device-desktop me-2" />
                Devices
              </div>
            ),
          },
          {
            key: "6",
            label: (
              <div
                data-bs-toggle="modal"
                data-bs-target="#configurationmodel"
                onClick={() => setSelectedConfigRecord(record)}
              >
                <i className="fa-solid fa-gears me-2"></i>
                Configurations
              </div>
            ),
          },
          {
            key: "7",
            label: (
              <div
                data-bs-toggle="modal"
                data-bs-target="#generatelicence"
                onClick={() => setSelectedGeneratedLicence(record)}
              >
                <i className="fa-solid fa-key me-2"></i>
                Generate Licence
              </div>
            ),
          },
        ];

        return (
          <Dropdown
            menu={{ items }}
            trigger={["click"]}
            placement="bottomRight"
          >
            <Link
              to="#"
              className="p-2 d-flex align-items-center justify-content-center"
            >
              <i className="ti ti-dots-vertical" />
            </Link>
          </Dropdown>
        );
      },
    },
  ];

  const [companiesData, setCompaniesData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingProducts, setLoadingProducts] = useState(true);

  const [productOptions, setProductOptions] = useState([]);
  console.log(productOptions, "productoptions");
  const [selectedProduct, setSelectedProduct] = useState(null);

  const [productTypeOptions, setProductTypeOptions] = useState([]);

  const [modalData, setModalData] = useState([]);
  console.log(modalData, "modaldata");
  const [counts, setCounts] = useState([]);
  console.log(counts, "counts");

  const [serviceType, setServiceType] = useState([]);
  console.log(serviceType, "servicetype");

  const [processingType, setProcessingType] = useState([]);

  const [subscriptionType, setSubscriptionType] = useState([]);

  // const [rollcallType, setRollcallType] = useState([]);
  const [addLoading, setAddLoading] = useState(false);

  const [licenseTypeOptions, setLicenseTypeOptions] = useState([]);
  const [loadingLicenseTypes, setLoadingLicenseTypes] = useState(false);

  const [subscriptionStatusOptions, setSubscriptionStatusOptions] = useState(
    []
  );
  const [loadingSubscriptionStatus, setLoadingSubscriptionStatus] =
    useState(false);

  const resetClientForm = () => {
    setClientData({
      SuperId: "",
      OrgName: "",
      Email: "",
      Address: "",
      Mobile: "",
      SubscriptionType: null,
      LicenseType: null,
      StatusType: null,
      SubscribedOn: "",
     
    });
  };

  const [clientData, setClientData] = useState({
    SuperId: "",
    OrgName: "",
    Address: "",
    Email: "",
    Mobile: "",
    SubscriptionType: null,
    LicenseType: null,
    StatusType: null,
    SubscribedOn: "",
  });

  // const [NotifytModalData, setNotifyModalData] = useState({
  //   OrgName: "",
  //   PrimaryEmailAddr: "",
  //   PrimaryMobile: "",
  //   Subject: "",
  //   Message: "",
  //   SuperId: "",
  // });

  // console.log(NotifytModalData, "notificationdata");

  const [selectedLocationRecord, setSelectedLocationRecord] = useState(null);
  const [selectedDeviceRecord, setSelectedDeviceRecord] = useState(null);
  const [selectedConfigRecord, setSelectedConfigRecord] = useState(null);
  const [selectedEditRecord, setSelectedEditRecord] = useState(null);
  const [selectedNotifyRecord, setSelectedNotifyRecord] = useState(null);
  const [selectedGeneratedLicence, setSelectedGeneratedLicence] =
    useState(null);

  // const fetchCompanyDetails = (record) => {
  //   setNotifyModalData({
  //     SuperId: record.SuperId || "",
  //     OrgName: record.OrgName || "",
  //     PrimaryEmailAddr: record.PrimaryEmailAddr || "",
  //     PrimaryMobile: record.PrimaryMobile || "",
  //     Subject: "Important Notification From Our Team",
  //     Message: `    Hi, ${record.OrgName}
  //                   We noticed that your attendance data has not been updated for the past few days.
  //                   To help us assist you better, we kindly request you to get in touch with our support
  //                   team at your earliest convenience.

  //                   Warm regards,
  //                   PerennialCode Support Team

  //                   Contact Us:
  //                   Phone: {8297230010}
  //                   Email: {support@perennialcode.in}`,
  //   });
  // };

  const fetchCompaniesData = async (selectedProduct) => {
    setLoading(true);

    try {
      const response = await fetch(
        // `${API_BASE_URL}/api/getorganization?ProductTypeId=${selectedProduct}`
        ` ${API_BASE_URL}api/org/getallorganization?ProductId=${selectedProduct}&IsActive=1`
      );
      const data = await response.json();
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      if (data.status === true) {
        setCompaniesData(data.ResultData);
      } else {
        setCompaniesData([]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchProducts = async () => {
    try {
      setLoadingProducts(true);
      const res = await fetch(`${API_BASE_URL}api/type/getproducttype`);

      if (!res.ok) throw new Error("Failed to fetch productOptions");
      const data = await res.json();

      if (data.status === true) {
        setProductOptions([
          { label: "All", value: 0 },
          ...data.ResultData.map((item) => ({
            label: item.ProductName,
            value: item.Id,
          })),
        ]);
        setProductTypeOptions(
          data.ResultData.map((item) => ({
            label: item.ProductName,
            value: String(item.Id),
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching productOptions:", error);
    } finally {
      setLoadingProducts(false);
    }
  };

  // const sendWhatsAppNotification = async () => {
  //   if (!NotifytModalData.PrimaryMobile || !NotifytModalData.Message) {
  //     alert("Contact number and message are required!");
  //     return;
  //   }

  //   try {
  //     const payload = {
  //       number: NotifytModalData.PrimaryMobile,
  //       client: NotifytModalData.OrgName,
  //       subject: NotifytModalData.Subject,
  //       message: NotifytModalData.Message,
  //     };

  //     const res = await axios.post(
  //       `${API_NOTIFY_URL}pcode/sendWhatsAppmessageHealthcheck`,
  //       payload
  //     );

  //     if (res.data.success) {
  //       alert("WhatsApp message sent successfully!");
  //     } else {
  //       alert("Failed to send message!");
  //     }
  //   } catch (err) {
  //     console.error(err);
  //     alert("Something went wrong!");
  //   }
  // };

  // const sendWhatsAppNotification = async () => {
  //   if (!NotifytModalData.PrimaryMobile || !NotifytModalData.Message) {
  //     alert("Contact number and message are required!");
  //     return;
  //   }

  //   try {
  //     // WhatsApp Payload
  //     const whatsappPayload = {
  //       number: NotifytModalData.PrimaryMobile,
  //       client: NotifytModalData.OrgName,
  //       subject: NotifytModalData.Subject,
  //       message: NotifytModalData.Message,
  //     };

  //     // Mail Payload
  //     const mailPayload = {
  //       superid: NotifytModalData.SuperId,
  //       toaddr: NotifytModalData.PrimaryEmailAddr,
  //       message: NotifytModalData.Message,
  //       subject: NotifytModalData.Subject || "Test Message",
  //     };

  //     console.log(mailPayload, "mailpayload");

  //     // Send both APIs together
  //     const [whatsappRes, mailRes] = await Promise.all([
  //       axios.post(
  //         `${API_NOTIFY_URL}pcode/sendWhatsAppmessageHealthcheck`,
  //         whatsappPayload
  //       ),

  //       axios.post(
  //         "https://notify.ibizaccounts.com/api/notifyservice.php?action=sendmail",
  //         mailPayload
  //       ),
  //     ]);

  //     console.log("WhatsApp Response:", whatsappRes.data);
  //     console.log("Mail Response:", mailRes.data);

  //     if (whatsappRes.data.success || mailRes.data.success) {
  //       alert("WhatsApp and Mail sent successfully!");
  //     } else {
  //       alert("Failed to send notifications!");
  //     }
  //   } catch (err) {
  //     console.error(err);
  //     alert("Something went wrong!");
  //   }
  // };

  const fetchServiceTypes = async () => {
    try {
      // setLoadingService(true);
      const res = await fetch(`${API_BASE_URL}api/type/getservicetypes`);

      if (!res.ok) throw new Error("Failed to fetch ServiceTypes");
      const data = await res.json();

      if (data.status === true) {
        setServiceType(
          data?.ResultData?.map((item) => ({
            label: item?.ServiceName,
            value: String(item.Id),
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching service types:", error);
    } finally {
      // setLoadingService(false);
    }
  };

  const fetchProcessingTypes = async () => {
    try {
      // setLoadingService(true);
      const res = await fetch(`${API_BASE_URL}api/type/getprocessingtype`);

      if (!res.ok) throw new Error("Failed to fetch processingtype");
      const data = await res.json();

      if (data.status === true) {
        setProcessingType(
          data.ResultData.map((item) => ({
            label: item.Name, // FIXED
            value: String(item.Id),
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching service types:", error);
    } finally {
      // setLoadingService(false);
    }
  };

  const fetchSubscriptionTypes = async () => {
    try {
      // setLoadingService(true);
      const res = await fetch(`${API_BASE_URL}api/type/getsubscriptiontype`);

      if (!res.ok) throw new Error("Failed to fetch subscriptiontype");
      const data = await res.json();

      if (data.status === true) {
        setSubscriptionType(
          data?.ResultData?.map((item) => ({
            label: item?.Name, // FIXED
            value: String(item.Id),
          }))
        );
      }
    } catch (error) {
      console.error("Error fetching service types:", error);
    } finally {
      // setLoadingService(false);
    }
  };

  // const fetchRollcallTypes = async () => {
  //   try {
  //     // setLoadingService(true);
  //     const res = await fetch(`${API_BASE_URL}api/getRollcallType`);

  //     if (!res.ok) throw new Error("Failed to fetch processingtype");
  //     const data = await res.json();

  //     if (data.Status === true) {
  //       setRollcallType(
  //         data?.ResultData?.map((item) => ({
  //           label: item?.RollcallTypes, // FIXED
  //           value: String(item?.Id),
  //         }))
  //       );
  //     }
  //   } catch (error) {
  //     console.error("Error fetching service types:", error);
  //   } finally {
  //     // setLoadingService(false);
  //   }
  // };

  const fetchCompanyDetail = async (record) => {
    if (!record) return;

    setModalData(record);
  };

  const fetchCounts = async () => {
    try {
      const response = await fetch(
        `${API_BASE_URL}api/dashboard/getcountsbyproduct `
      );

      const data = await response.json();
      console.log(data);

      if (data?.status === true) {
        setCounts(data.ResultData);
      }
    } catch (error) {
      console.error("Error fetching counts:", error);
    }
  };

  const fetchLicenseTypes = async () => {
    try {
      setLoadingLicenseTypes(true);

      const response = await fetch(`${API_BASE_URL}api/type/getlicensetype`);

      const data = await response.json();

      console.log(data);

      if (data?.status === true) {
        const formattedData = data.ResultData.map((item) => ({
          label: item.Name,
          value: item.Id,
        }));

        setLicenseTypeOptions(formattedData);
      } else {
        setLicenseTypeOptions([]);
      }
    } catch (error) {
      console.error("Error fetching license types:", error);
    } finally {
      setLoadingLicenseTypes(false);
    }
  };

  const fetchSubscriptionStatus = async () => {
    try {
      setLoadingSubscriptionStatus(true);

      const response = await fetch(`${API_BASE_URL}api/type/getstatustype`);

      const data = await response.json();

      console.log(data);

      if (data?.status === true) {
        const formattedData = data.ResultData.map((item) => ({
          label: item.Name,
          value: item.Id,
        }));

        setSubscriptionStatusOptions(formattedData);
      } else {
        setSubscriptionStatusOptions([]);
      }
    } catch (error) {
      console.error("Error fetching subscription status:", error);
    } finally {
      setLoadingSubscriptionStatus(false);
    }
  };

  const addClient = async () => {
    setAddLoading(true);

    try {
      const payload = {
        SuperId: Number(clientData.SuperId),
        UserId: userData?.[0]?.UserId,
        OrgName: clientData.OrgName,
        SubscribedOn: clientData.SubscribedOn,
        Address: clientData.Address,
        PrimaryEmail: clientData.Email,
        PrimaryMobile: clientData.Mobile,
        LicenseType: clientData.LicenseType,
        SubscriptionType: Number(clientData.SubscriptionType),
        StatusType: Number(clientData.StatusType),
      };

      console.log(payload, "payloaddddddddddddddddd");

      const response = await fetch(`${API_BASE_URL}api/org/addorg`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      console.log(result);

      if (result?.ResultData?.[0]?.Status === "1") {
        Swal.fire("Success", "Client Added Successfully", "success");

        document.getElementById("closeAddCompanyModal").click();

        resetClientForm();

        fetchCompaniesData(0);
      } else {
        Swal.fire("Error", result?.message || "Unable to Add Client", "error");
      }
    } catch (error) {
      console.error(error);

      Swal.fire("Error", "Something Went Wrong", "error");
    } finally {
      setAddLoading(false);
    }
  };

  // const handleChange = (e) => {
  //   setNotifyModalData({
  //     ...NotifytModalData,
  //     [e.target.name]: e.target.value,
  //   });
  // };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setClientData((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    // load all when page opens
    fetchCompaniesData(0);
  }, []);

  useEffect(() => {
    if (selectedProduct === null) return; // 🚫 don't call API yet

    fetchCompaniesData(selectedProduct);
  }, [selectedProduct]);

  useEffect(() => {
    fetchCounts();
    fetchProducts();
    fetchServiceTypes();
    fetchProcessingTypes();
    fetchSubscriptionTypes();
    // fetchRollcallTypes();
    fetchLicenseTypes();
    fetchSubscriptionStatus();
  }, []);

  useEffect(() => {
    const modal = document.getElementById("add_company");

    const handleClose = () => {
      resetClientForm();
    };

    if (modal) {
      modal.addEventListener("hidden.bs.modal", handleClose);
    }

    return () => {
      if (modal) {
        modal.removeEventListener("hidden.bs.modal", handleClose);
      }
    };
  }, []);

  const handleRefresh = () => {
    window.location.reload();
  };

  const rollCallCount =
    counts.find((item) => item.ProductType === "RollCall")?.TotalCount || 0;

  const ibizCount =
    counts.find((item) => item.ProductType === "Ibiz")?.TotalCount || 0;

  const campusCount =
    counts.find((item) => item.ProductType === "Campus")?.TotalCount || 0;

  const otherCount =
    counts.find((item) => item.ProductType === "Other")?.TotalCount || 0;

  useEffect(() => {
    if (productOptions?.length > 0 && !selectedProduct) {
      setSelectedProduct(productOptions[0].value);
    }
  }, [productOptions]);

  return (
    <>
      {addLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(255,255,255,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <Spin size="large" />
        </div>
      )}
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Clients</h4>
                <h6>Manage your Clients</h6>
              </div>
            </div>
            <ul className="table-top-head">
              {/* <TooltipIcons />
              <CollapesIcon /> */}
              <li onClick={handleRefresh} style={{ cursor: "pointer" }}>
                <RefreshIcon />
              </li>
            </ul>
            <div className="page-btn">
              <Link
                to="#"
                className="btn btn-primary"
                data-bs-toggle="modal"
                data-bs-target="#add_company"
                title="Add"
              >
                <i
                  className="ti ti-circle-plus "
                  style={{ fontSize: "18px" }}
                ></i>
              </Link>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-3 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center overflow-hidden">
                    <div className="ms-2 overflow-hidden">
                      <p className="fs-12 fw-medium mb-1 ">RollCall Clients</p>
                      <h4>{rollCallCount}</h4>
                    </div>
                  </div>
                  <div>
                    {" "}
                    <span className="avatar avatar-lg bg-primary flex-shrink-0">
                      <i className="ti ti-clipboard-check fs-3" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center overflow-hidden">
                    <div className="ms-2 overflow-hidden">
                      <p className="fs-12 fw-medium mb-1 ">IBIZ Clients</p>
                      <h4>{ibizCount}</h4>
                    </div>
                  </div>
                  <div>
                    <span className="avatar avatar-lg bg-success flex-shrink-0">
                      <i className="ti ti-building fs-3" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center overflow-hidden">
                    <div className="ms-2 overflow-hidden">
                      <p className="fs-12 fw-medium mb-1">Campus Clients</p>
                      <h4>{campusCount}</h4>
                    </div>
                  </div>
                  <div>
                    <span className="avatar avatar-lg bg-skyblue flex-shrink-0">
                      <i className="ti ti-building-bank  fs-3" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-body d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center overflow-hidden">
                    <div className="">
                      <p className="fs-12 fw-medium mb-1 text-truncate">
                        Other Clients
                      </p>
                      <h4>{otherCount}</h4>
                    </div>
                  </div>
                  <div>
                    <span className="avatar avatar-lg bg-danger flex-shrink-0">
                      <i className="ti ti-tool  fs-3" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5></h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-3">
                  <Select
                    placeholder="Select Product"
                    style={{ width: 150 }}
                    loading={loadingProducts}
                    options={productOptions}
                    onChange={(value) => setSelectedProduct(Number(value))}
                    value={selectedProduct}
                  />
                </div>
              </div>
            </div>

            <div className="card-body p-0">
              <div className="table-responsive">
                {loading ? (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "250px", // adjust height if needed
                    }}
                  >
                    <Spin size="large" />
                  </div>
                ) : (
                  <Table1 columns={columns} dataSource={companiesData} />
                )}
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
        <Location record={selectedLocationRecord} />{" "}
        <Devicesmodel record={selectedDeviceRecord} />
        <ConfigrationModel record={selectedConfigRecord} />
        <EditClient
          record={selectedEditRecord}
          serviceType={serviceType}
          productTypeOptions={productTypeOptions}
          subscriptionType={subscriptionType}
          licenseTypeOptions={licenseTypeOptions}
          processingType={processingType}
          subscriptionStatusOptions={subscriptionStatusOptions}
          getClients={fetchCompaniesData}
        />
        <Notify record={selectedNotifyRecord} />
        <GenerateLicence record={selectedGeneratedLicence} />
      </div>

      {/* Add Company */}
      <div className="modal fade" id="add_company">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add New Client</h4>
              <button
                id="closeAddCompanyModal"
                type="button"
                className="btn-close custom-btn-close p-0"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => resetClientForm()}
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body pb-0">
                <div className="row">
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">
                        Super ID <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        name="SuperId"
                        value={clientData.SuperId}
                        onChange={handleInputChange}
                        className="form-control"
                        placeholder="Enter SuperId"
                      />
                    </div>
                  </div>

                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">
                        Cilent Name <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        name="OrgName"
                        value={clientData.OrgName}
                        onChange={handleInputChange}
                        className="form-control"
                        placeholder="Enter Name"
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">Email</label>
                      <input
                        type="email"
                        name="Email"
                        value={clientData.Email}
                        onChange={handleInputChange}
                        className="form-control"
                        placeholder="Enter Email"
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">
                        Mobile <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        name="Mobile"
                        value={clientData.Mobile}
                        onChange={handleInputChange}
                        className="form-control"
                        placeholder="Enter Mobile number"
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">Subscribed On</label>
                      <input
                        type="date"
                        name="SubscribedOn"
                        value={clientData.SubscribedOn}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  </div>
                  {/* <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">LocationName</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Location Name"
                        value={clientData.LocationName}
                        onChange={(e) =>
                          setClientData({
                            ...clientData,
                            LocationName: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div> */}

                  {/* <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">Renewal Date</label>
                      <input
                        type="date"
                        name="RenewalDate"
                        value={clientData.RenewalDate}
                        onChange={handleInputChange}
                        className="form-control"
                      />
                    </div>
                  </div> */}
                  {/* <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">
                        Service Type <span className="text-danger">*</span>
                      </label>

                      <Select
                        className="w-100"
                        style={{ width: 100, height: 38 }}
                        options={serviceType}
                        placeholder="Choose"
                        value={clientData.ServiceType}
                        onChange={(value) => {
                          setClientData({
                            ...clientData,
                            ServiceType: value, // <-- update state here
                          });
                        }}
                        getPopupContainer={(trigger) => trigger.parentNode}
                        popupClassName=""
                        dropdownStyle={{ zIndex: 9999 }}
                        dropdownRender={(menu) => (
                          <div style={{ zIndex: 9999, position: "relative" }}>
                            {menu}
                          </div>
                        )}
                      />
                    </div>
                  </div> */}
                  {/* <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">
                        Product Type <span className="text-danger"> *</span>
                      </label>

                      <Select
                        className="w-100"
                        style={{ width: 100, height: 38 }}
                        options={productTypeOptions}
                        placeholder="Choose"
                        value={clientData.ProductType}
                        loading={loadingProducts}
                        onChange={(value) => {
                          setClientData({
                            ...clientData,
                            ProductType: value, // <-- update state here
                          });
                        }}
                        getPopupContainer={(trigger) => trigger.parentNode}
                        popupClassName=""
                        dropdownStyle={{ zIndex: 9999 }}
                        dropdownRender={(menu) => (
                          <div style={{ zIndex: 9999, position: "relative" }}>
                            {menu}
                          </div>
                        )}
                      />
                    </div>
                  </div> */}
                  <div className="col-md-4">
                    <div className="mb-3 ">
                      <label className="form-label">
                        Subscription Type
                        <span className="text-danger"> *</span>
                      </label>
                      <Select
                        className="w-100"
                        style={{ width: 100, height: 38 }}
                        options={subscriptionType}
                        placeholder="select subscription type"
                        value={clientData.SubscriptionType}
                        // loading={loadingProducts}
                        onChange={(value) => {
                          setClientData({
                            ...clientData,
                            SubscriptionType: value, // <-- update state here
                          });
                        }}
                        getPopupContainer={(trigger) => trigger.parentNode}
                        popupClassName=""
                        dropdownStyle={{ zIndex: 9999 }}
                        dropdownRender={(menu) => (
                          <div style={{ zIndex: 9999, position: "relative" }}>
                            {menu}
                          </div>
                        )}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">
                        License Type <span className="text-danger">*</span>
                      </label>

                      <Select
                        className="w-100"
                        style={{ width: 100, height: 38 }}
                        options={licenseTypeOptions}
                        loading={loadingLicenseTypes}
                        placeholder="select license type"
                        value={clientData.LicenseType}
                        onChange={(value) => {
                          setClientData({
                            ...clientData,
                            LicenseType: value,
                          });
                        }}
                        getPopupContainer={(trigger) => trigger.parentNode}
                      />
                    </div>
                  </div>
                  {/* <div className="col-md-4">
                    <div className="mb-3 ">
                      <label className="form-label">
                        Processing Type <span className="text-danger"> *</span>
                      </label>
                      <Select
                        className="w-100"
                        style={{ width: 100, height: 38 }}
                        options={processingType}
                        placeholder="select processing type"
                        value={clientData.ProcessingType}
                        onChange={(value) => {
                          setClientData({
                            ...clientData,
                            ProcessingType: value, // <-- update state here
                          });
                        }}
                        getPopupContainer={(trigger) => trigger.parentNode}
                        popupClassName=""
                        dropdownStyle={{ zIndex: 9999 }}
                        dropdownRender={(menu) => (
                          <div style={{ zIndex: 9999, position: "relative" }}>
                            {menu}
                          </div>
                        )}
                      />
                    </div>
                  </div> */}
                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">Subscription Status</label>

                      <Select
                        className="w-100"
                        style={{ width: 100, height: 38 }}
                        options={subscriptionStatusOptions}
                        loading={loadingSubscriptionStatus}
                        placeholder="select status"
                        value={clientData.StatusType}
                        onChange={(value) => {
                          setClientData({
                            ...clientData,
                            StatusType: value,
                          });
                        }}
                        getPopupContainer={(trigger) => trigger.parentNode}
                      />
                    </div>
                  </div>
                  {/* <div className="col-md-4">
                    <div className="mb-3 ">
                      <label className="form-label">Rollcall Type</label>
                      <Select
                        className="w-100"
                        options={rollcallType}
                        placeholder="Choose"
                        value={clientData.RollcallType}
                        onChange={(value) => {
                          setClientData({
                            ...clientData,
                            RollcallType: value, // <-- update state here
                          });
                        }}
                        getPopupContainer={(trigger) => trigger.parentNode}
                        popupClassName=""
                        dropdownStyle={{ zIndex: 9999 }}
                        dropdownRender={(menu) => (
                          <div style={{ zIndex: 9999, position: "relative" }}>
                            {menu}
                          </div>
                        )}
                      />
                    </div>
                  </div> */}

                  <div className="col-md-4">
                    <div className="mb-3">
                      <label className="form-label">Address</label>
                      <textarea
                        className="form-control"
                        rows={2}
                        placeholder="Enter Address"
                        value={clientData.Address}
                        onChange={(e) =>
                          setClientData({
                            ...clientData,
                            Address: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                  onClick={() => resetClientForm()}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={addClient}
                  //   data-bs-dismiss="modal"
                  // disabled={addLoading}
                >
                  {/* {addLoading ? "Submitting..." : "Save"} */}
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* View model */}
      <div className="modal fade" id="company_detail">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="text-gray-9 fw-medium">
                {" "}
                View Details Of{" "}
                <span style={{ color: "orange" }}>{modalData?.OrgName}</span>
              </h3>
              <div className="mx-3">
                <label className="text-muted fw-semibold"></label>
                <span
                  className={`${
                    modalData?.IsActive ? "bg-success" : "bg-danger"
                  }`}
                  style={{
                    width: "15px",
                    height: "15px",
                    borderRadius: "50%",
                    display: "inline-block",
                  }}
                ></span>
              </div>
              <button
                type="button"
                className="btn-close custom-btn-close p-0"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <div className="p-3">
              <div className="row g-3">
                <div className="col-md-4">
                  <label className="text-muted fw-semibold">Super ID</label>
                  <p className="fw-medium">{modalData?.SuperId || "-"}</p>
                </div>

                <div className="col-md-4">
                  <label className="text-muted fw-semibold">Product Type</label>
                  <p className="fw-medium">{modalData?.ProductType || "-"}</p>
                </div>

                <div className="col-md-4">
                  <label className="text-muted fw-semibold">
                    Primary Email
                  </label>
                  <p className="fw-medium">
                    {modalData?.PrimaryEmailAddr || "-"}
                  </p>
                </div>

                <div className="col-md-4">
                  <label className="text-muted fw-semibold">
                    Primary Mobile
                  </label>
                  <p className="fw-medium">{modalData?.PrimaryMobile || "-"}</p>
                </div>

                <div className="col-md-4">
                  <label className="text-muted fw-semibold">
                    Subscribed Type
                  </label>
                  <p className="fw-medium">
                    {modalData?.SubscriptionType || "-"}
                  </p>
                </div>
                <div className="col-md-4">
                  <label className="text-muted fw-semibold">Service Type</label>
                  <p className="fw-medium">{modalData?.ServiceType || "-"}</p>
                </div>
                <div className="col-md-4">
                  <label className="text-muted fw-semibold">
                    Subscribed On
                  </label>
                  <p className="fw-medium">{modalData?.SubscribedOn || "-"}</p>
                </div>

                <div className="col-md-4">
                  <label className="text-muted fw-semibold">Renewal On</label>
                  <p className="fw-medium">{modalData?.RenewalDt || "-"}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      
    </>
  );
};

export default Companies;
